import useEnhanceApiClient from './useEnhanceApiClient';
import ApiClient from 'src/lib/api_client';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

type EventData = {
  eventName: string;
  eventId: string;
  contentType?: 'product' | 'product_group';
  eventSourceUrl?: string;
  currency?: string;
  country?: string;
  orderItemId?: number;
  optionId?: number;
  orderNumber?: string;
  price?: number;
  contentName: string;
  contentId: number | string;
  quantity?: number;
  customer?: {
    name: string;
    email: string;
    phoneNumber: string;
  };
};

const useFacebookPixelEvent = () => {
  const sendFacebookPixelEvent = useEnhanceApiClient(ApiClient.sendFacebookPixelEvent);
  const router = useRouter();

  return ({
    eventName,
    eventData,
  }: {
    eventName: 'ViewContent' | 'Purchase' | 'AddToCart';
    eventData: EventData;
  }) => {

    if (process.env.NEXT_PUBLIC_APP_ENV !== 'production') return;

    return sendFacebookPixelEvent({
      ...eventData,
      eventName: eventName,
      contentType: 'product',
      eventSourceUrl: new URL(router.asPath, location.href).href.split('?')[0],
      fbc: Cookies.get('_fbc'),
      fbp: Cookies.get('_fbp'),
    });
  };
};

export default useFacebookPixelEvent;
